import moment from "moment";

export const dateToString = (date: moment.MomentInput | null): string =>
  moment(date).format("MM/DD/YYYY");

export const skipReasons = [
  { value: "1st Refusal" },
  { value: "2nd Refusal" },
  { value: "Dislikes unit", text: "Reason" },
  { value: "Doesn't live in the area" },
  { value: "Doesn't want to switch school districts" },
  { value: "Household size too large for unit" },
  { value: "Household size too small for unit" },
  { value: "In a lease", date: "Preferred Move-In Date" },
  { value: "No response to outreach" },
  { value: "Not interested" },
  { value: "Not income qualified" },
  { value: "Not looking to move yet", date: "Preferred Move-In Date" },
  { value: "Prefers a different unit size", unitSize: "Preferred Unit Size" },
  { value: "Rent too high" },
  { value: "Unit doesn't meet needs", text: "Reason" },
  { value: "Waiting on a Section 8 voucher or other subsidy" },
  { value: "Other", text: "Skip Reason", required: true },
];
export const unitSizes = [
  "Studio",
  "1 Bedroom",
  "2 Bedroom",
  "3 Bedroom",
  "4 Bedroom",
  "Other",
];

export const moveInDateToString = (date: moment.MomentInput | null): string =>
  `preferred move-in date: ${date ? dateToString(date) : "N/A"}`;
